<template>
    <b-modal ref="customizationModal"
             v-model="visible"
             centered
             size="lg"
             header-bg-variant="white">
        <template #modal-header>
            <h4 class="header-title">自定义显示顺序</h4>
        </template>
        <div class="d-flex flex-column">
            <h5>拖动以调整顺序</h5>
            <draggable v-model="customizedList" @update="dataDragEnd" v-bind="draggableConfig">
                <transition-group class="d-flex flex-wrap">
                    <div v-for="item of customizedList" :key="item.key">
                        <b-button variant="info"
                                  size="lg"
                                  class="mt-1 mr-1 drag-item"
                                  @click="handleItemClick(item)">
                            {{ ifI18n(item.label) }}
                        </b-button>
                    </div>
                </transition-group>
            </draggable>
            <h5 class="mt-4">选择显示项</h5>
            <div class="d-flex flex-wrap">
                <b-button v-for="item of localeList"
                          :variant="item.selected ? 'secondary' : 'outline-secondary'"
                          size="lg"
                          class="mt-1 mr-1"
                          :key="item.key"
                          @click="handleItemClick(item)">
                    {{ ifI18n(item.label) }}
                </b-button>
            </div>
        </div>
        <template #modal-footer>
            <b-button variant="outline-primary" @click="includeAll">Include All</b-button>
            <b-button variant="outline-secondary" @click="handleClear">Clear Configuration</b-button>
            <b-button variant="outline-danger" @click="visible=false">Cancel</b-button>
            <b-button variant="primary" @click="handleSave">Save</b-button>
        </template>
    </b-modal>
</template>

<script>
import draggable from "vuedraggable";
import {startCase} from "lodash";

export default {
    name: "CustomizeFields",
    components: {draggable},
    props: {
        collection: Array,
        currentOrder: Array,
        localstorageKey: String,
    },
    data() {
        return {
            visible: false,
            localeList: [],
            customizedList: [],

            draggableConfig: {
                animation: 500
            }
        }
    },
    created() {
        this.handleInit(this.collection);
    },
    mounted() {
        //avoid Firefox to open new tag when drag
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
    },
    methods: {
        handleInit(collection) {
            if (collection) {
                let tempList = JSON.parse(JSON.stringify(collection));
                let tempObject = {};
                for (let item of tempList) {
                    if (typeof item === 'string') {
                        tempObject[item] = {
                            key: item,
                            label: item
                        };
                    } else if (item.key) {
                        if (!item.label) {
                            item.label = startCase(item.key);
                        }
                        tempObject[item.key] = item;
                    }
                }
                this.localeList = Object.values(tempObject);
                tempList = [];
                if (this.currentOrder) {
                    tempList = this.currentOrder;
                } else if (this.localstorageKey) {
                    let ls = localStorage[this.localstorageKey];
                    tempList = ls ? JSON.parse(ls) : [];
                }
                for (let item of tempList) {
                    let key = typeof item === 'string' ? item : item.key;
                    let target = this.localeList.find(f => f.key && f.key === key);
                    if (target) {
                        target.selected = true;
                        this.customizedList.push(target);
                    }
                }
            }
        },
        handleSave() {
            let tempList = [];
            for (let item of this.customizedList) {
                tempList.push(item.key);
            }
            if (this.localstorageKey) {
                localStorage[this.localstorageKey] = JSON.stringify(tempList);
            }
            this.visible = false;
            this.$emit('save', tempList);
            this.$emit('change', tempList);
        },
        handleClear() {
            this.customizedList = [];
            this.localeList.forEach(o => o.selected = false);
            if (this.localstorageKey) {
                localStorage.removeItem(this.localstorageKey);
            }
            this.visible = false;
            this.$emit('clear');
            this.$emit('change');
        },
        handleItemClick(item) {
            let index = this.customizedList.findIndex(o => item.key === o.key);
            let selected = index >= 0;
            if (selected) {
                this.customizedList.splice(index, 1);
            } else {
                this.customizedList.push(item);
            }
            item.selected = !selected;
        },
        dataDragEnd(evt) {
            evt.preventDefault();
        },
        show() {
            this.handleInit(this.collection);
            this.visible = true;
        },
        ifI18n(label) {
            return this.$t(label, true);
        },

        includeAll() {
            let f = false;
            for (let item of this.localeList) {
                if (!item.selected) {
                    this.customizedList.push(item);
                    item.selected = true;
                    f = true;
                }
            }
            f && this.$emit('change');
        },
    }
}
</script>

<style scoped>
.header-title {
    margin: 0.5rem auto 0.5rem 0;
    color: black;
}

.drag-item {
    display: inline-flex;
}
</style>
